module.exports = __webpack_public_path__ + "img/2025-08-16b_1.b885ce73.jpg";